// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createHashHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';
import moment from "moment";
import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { partnerPermission, register, getcharityList, getSiteCity } from '../../../redux/actions/frontActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';

import {renderAlert,clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from "react-number-format";
import Cookies from 'universal-cookie';
import DatePicker from "react-date-picker";

const cookies = new Cookies();

let Recaptcha = require('react-recaptcha');

const history = createHashHistory();
let isLoading = "false";
class Register extends Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      firstName: '',
      lastName: '',
      phone:'',
      gender:'Male',
      dob:'',
      address1:'',
      address2:'',
      country:'',
      state:'',
      city:'',
      cityID:'',
      cemail:'',
      email:'',
      password:'',
      cpassword:'',
      zipcode:'',
      stateAbbr:'',
      username:'',
      countryerror:'false',
      stateerror:'false',
      cityerror:'false',
      affiliated_by: '',
      showAlert: false,
      countryName:'United States',
      disabled:'',
      enabled: '',
      required: '',
      hover: false,
      charity: '',
      charity_id: '',
      disabled: false,
      cityList: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  onChangeStartDate = date => { this.setState({ dob: date, dobError: "" })};

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear(){
    this.setState({
      firstName: '',
      lastName: '',
      phone:'',
      gender:'Male',
      dob:'',
      address1:'',
      address2:'',
      cemail:'',
      email:'',
      password:'',
      cpassword:'',
      zipcode:'',
      username:'',
      countryName:'United States',
      enabled: '',
      required: '',
      charity: '',
      charity_id: '',
      charityOption: 'disable',
      country: '',
      state: '',
      cityID: '',
    });
  }

  componentWillMount() {
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    isLoading = "true";
    this.props.partnerPermission('registration-form/fields');
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
     if(siteData){
      this.setState({siteName: siteData.siteName, charityOption: siteData.charity});
    }
    this.props.getcharityList();
    this.props.getSiteCity();
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if(this.props.permission !== nextProps.permission){
      if(nextProps.permission){
        if(nextProps.permission.data){
          this.setState({
            enabled: nextProps.permission.data.enabled,
            required: nextProps.permission.data.required,
          })
        }
        isLoading = "false";
      }
    }
    if(this.props.getCharity !== nextProps.getCharity){
      if(nextProps.getCharity){
        this.setState({charity: nextProps.getCharity});
      }
    }
    if(this.props.regStatus != nextProps.regStatus){
      if(nextProps.regStatus){
          this.setState({showAlert:true});
          this.props.renderAlert('success', "User account has been created successfully.");
          this.Clear();
          window.scrollTo(0, 0);
          this.props.partnerPermission('registration-form/fields');
          let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
           if(siteData){
            this.setState({siteName: siteData.siteName, charityOption: siteData.charity});
          }
          this.props.getcharityList();
      }
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
         this.setState({showAlert:true});
        this.handleShow();
        this.props.renderAlert('warning', nextProps.error);
        window.scrollTo(0, 0);
        let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
        if(siteData){
          this.setState({siteName: siteData.siteName, charityOption: siteData.charity});
        }
        this.props.partnerPermission('registration-form/fields');
        this.props.getcharityList();
      }
    }

    if(this.props.message !== nextProps.message){
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
        //Clear();
    }

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }

  }

  componentWillUpdate(nextProps, nextState){
  }

  validate = () => { 
    let isError = false;
    const errors = {};

    if(!this.state.firstName && this.state.required.firstName == '0'){
      isError = true;
      this.setState({firstNameError:"red"})
    }

    if(!this.state.lastName && this.state.required.lastName == '0'){
      isError = true;
      this.setState({lastNameError:"red"})
    }

    if(!this.state.gender && this.state.required.gender == '0'){
      isError = true;
      this.setState({genderError:"red"})
    }

    if(!this.state.address1 && this.state.required.address1 == '0'){
      isError = true;
      this.setState({address1Error:"red"})
    }

    if(!this.state.address2 && this.state.required.address2 == '0'){
      isError = true;
      this.setState({address2Error:"red"})
    }

    if(!this.state.username && this.state.required.userName == '0'){
      isError = true;
      this.setState({usernameError:"red"})
    }

    if(!this.state.country  && this.state.required.country == '0'){
      isError = true;
      this.setState({countryError:"red"})
    }
   
    if(!this.state.state && this.state.required.state == '0'){
      isError = true;
      this.setState({stateError:"red"})
    }
    if(!this.state.cityID && this.state.required.city == '0'){
      isError = true;
      this.setState({cityIDError:"red"})
    }

    if(!this.state.email  && this.state.required.email == '0'){
      isError = true;
      this.setState({emailError:"red"})
    }else if(this.state.email){
      if(this.getValidationEmailState()){
       isError = true;
       this.setState({emailError:"red"})
      }
     }

     if(this.state.cemail  && this.state.required.confirm_email == '0'){
      if(this.getValidationEmailState2()){
        isError = true;
        this.setState({cemailError:"red"})
       }
     }


    if((this.state.email != this.state.cemail) && ( this.state.required.email == '0' && this.state.required.userName == '0')){
      isError = true;
      this.setState({cemailError:"red"})
    }

    if(!this.state.password  && this.state.required.password == '0'){
      isError = true;
      this.setState({passwordError:"red"})
    }

    if((this.state.password != this.state.cpassword) && ( this.state.required.password == '0'  && this.state.required.confirm_password == '0')){
      isError = true;
      this.setState({cpasswordError:"red"})
    }

    if(!this.state.phone && this.state.required.phone == '0'){
        isError = true;
        this.setState({phoneError:"red"})
    }

    if(!this.state.zipcode && this.state.required.zipCode == '0'){
        isError = true;
        this.setState({zipcodeError:"red"})
    }

    if(!this.state.dob && this.state.required.dob == '0'){
        isError = true;
        this.setState({dobError:"red"})
    }

    

    return isError;
  }

  getValidationEmailState() {
    if(this.state.email){
      const length = this.state.email.length;
      if(length !==0){
      let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      if(!emailpattern.test(this.state.email)){
        return 'error';
      }
      }
    }
    
    return null
  }

  getValidationEmailState2() {
    if(this.state.cemail){
      const length = this.state.cemail.length;
      if(length !==0){
      let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
      if(!emailpattern.test(this.state.cemail)){
        return 'error';
      }
      }
    }
    
    return null
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();
    let affiliateID = [];
    affiliateID=cookies.get('affiliateID');
    let affiliated_by="";
    if (typeof affiliateID != "undefined"){
      affiliated_by= affiliateID.affiliateID
    }

    if(!err){
      this.setState({disabled:true})
      let formData = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phone:this.state.phone,
        gender:this.state.gender,
        dob:moment(this.state.dob).format('YYYY-MM-DD'),
        address1:this.state.address1,
        address2:this.state.address2,
        country:this.state.country,
        state:this.state.state,
        city:this.state.city,
        cityID:this.state.cityID,
        email:this.state.email,
        password:this.state.password,
        zipcode:this.state.zipcode,
        stateAbbr:this.state.stateAbbr,
        userName:this.state.username,
        affiliated_by: affiliated_by,
        charity_id: this.state.charity_id,
      }
      isLoading="true";
      this.props.register(formData);
    }
  }

  getValidationState() {
    if(this.state.phone){
      const length = this.state.phone.length;
      if(length !==0){
      let mobilepattern= new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
      if(!mobilepattern.test(this.state.phone)){
        return 'error';
       
      }
      }
    }
    
    return null
  }

 render() {
    let enabled = (this.state.enabled) ? this.state.enabled : '';
    return(
      <div> 
          {isLoading == "true" ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
          )}
          <form onSubmit={this.handleSubmit}>            
            <div className="container">
                
                <div className="panel margin-top">
                  <header className="panel-heading">Personal Information</header>
                  <div className="panel-body">
                    {this.state.showAlert && this.state.alertMessage !=='' &&        
                      <div className="col-lg-12">
                        <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                          <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                        </Alert>
                      </div>
                    }
                    <Row>
                      <Col md={8} xs={12}>
                        <Row>
                          {(enabled.firstName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>First Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.firstName}
                                placeholder="First Name"
                                onChange={this.handleChange}
                                style={{borderColor:this.state.firstNameError}}
                                name="firstName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                          }

                          {(enabled.lastName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Last Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.lastName}
                                placeholder="Last Name"
                                onChange={this.handleChange}
                                style={{borderColor:this.state.lastNameError}}
                                name="lastName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                        <Row>
                          {(enabled.phone == '0') &&
                          <Col md={6} xs={12}>
                          <ControlLabel >Phone (format: xxx-xxx-xxxx) </ControlLabel>
                            <FormGroup controlId="formBasicPhoneText" validationState={this.getValidationState()}>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder="Enter Phone Number"
                                value={this.state.phone}
                                onChange={this.handleChange}
                                autoComplete="off"
                                style={{ borderColor: this.state.phoneError }}
                              />
                            </FormGroup>
                          </Col>
                          }
                          {(enabled.gender == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="gender">
                                <ControlLabel>Gender</ControlLabel>
                                <FormControl name="gender" style={{borderColor:this.state.genderError}} value={this.state.gender} componentClass="select">
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </FormControl>
                              </FormGroup>
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                        <Row>
                          {(enabled.dob == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Date of Birth </ControlLabel><br/>
                              <DatePicker
                                onChange={this.onChangeStartDate}
                                value={this.state.dob}
                                className={(this.state.dobError) ? "error" : ""}
                              />
                            </FormGroup>
                          </Col>
                          }
                          {(enabled.address1 == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address1</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address1}
                                placeholder="Address 1"
                                onChange={this.handleChange}
                                style={{borderColor:this.state.address1Error}}
                                name="address1"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                        <Row>
                          {(enabled.address2 == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="address2">
                                <ControlLabel>Address 2</ControlLabel>
                                <FormControl
                                  type="text"
                                  value={this.state.address2}
                                  placeholder="Address 2"
                                  onChange={this.handleChange}
                                  style={{borderColor:this.state.address2Error}}
                                  name="address2"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                          }
                          {(enabled.zipCode == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="zip">
                                <ControlLabel>Zip Code</ControlLabel>
                                <FormControl
                                  type="text"
                                  value={this.state.zipcode}
                                  placeholder="Zipcode"
                                  onChange={this.handleChange}
                                  style={{borderColor:this.state.zipcodeError}}
                                  name="zipcode"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                      </Col>
                      
                      {(enabled.country == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="country">
                            <ControlLabel>Country</ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.country) ? this.state.country : ''}
                              placeholder="Country"
                              onChange={this.handleChange}
                              name="country"
                              autoComplete="off"
                              style={{borderColor:this.state.countryError}}
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      }
                      {(enabled.state == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="state">
                            <ControlLabel>State</ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.state) ? this.state.state : ''}
                              placeholder="State"
                              onChange={this.handleChange}
                              name="state"
                              style={{borderColor:this.state.stateError}}
                              autoComplete="off"
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                      }
                      {(enabled.city == '0') &&
                      <Col md={4} xs={12}>
                      <FormGroup>
                        <ControlLabel>Subscriber City</ControlLabel>
                        <FormControl style={{borderColor:this.state.cityIDError}} componentClass="select" name="cityID" value={this.state.cityID} placeholder="select" onChange={this.handleChange}>
                            <option value="">Choose Region/City</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                <optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>
                              )
                            }
                        </FormControl>
                      </FormGroup>
                      </Col>
                      }
                    </Row> 
                  </div>
                </div>
                <div className="panel margin-top">
                  <header className="panel-heading">Login Information</header>
                  <div className="panel-body">
                    <Row>
                      {(enabled.userName == '0') &&
                      <Col md={4} xs={12}>
                          <FormGroup controlId="username">
                            <ControlLabel>User Name</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.username}
                              placeholder="User Name"
                              onChange={this.handleChange}
                              name="username"
                              autoComplete="off"
                              style={{borderColor:this.state.usernameError}}
                            />
                          </FormGroup>
                      </Col>
                      }
                      {(enabled.email == '0') &&
                      <Col md={4} xs={12}>
                      <ControlLabel>Email</ControlLabel>
                          <FormGroup controlId="email" validationState={this.getValidationEmailState()}>
                           
                            <FormControl
                              type="text"
                              value={this.state.email}
                              placeholder="Email"
                              onChange={this.handleChange}
                              name="email"
                              autoComplete="off"
                              style={{borderColor:this.state.emailError}}
                            />
                          </FormGroup>
                      </Col>
                      }
                      {(enabled.confirm_email == '0') &&
                      <Col md={4} xs={12}>
                      <ControlLabel>Confirm Email</ControlLabel>
                          <FormGroup controlId="cemail"  validationState={this.getValidationEmailState2()}>
                          
                            <FormControl
                              type="text"
                              value={this.state.cemail}
                              placeholder="Confirm Email"
                              onChange={this.handleChange}
                              name="cemail"
                              autoComplete="off"
                              style={{borderColor:this.state.cemailError}}
                            />
                          </FormGroup>
                      </Col>
                      }
                    </Row>
                    <Row>
                      {(enabled.password == '0') &&
                      <Col md={4} xs={12}>
                          <FormGroup controlId="password">
                            <ControlLabel>Password</ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.password}
                              placeholder="Password"
                              onChange={this.handleChange}
                              name="password"
                              autoComplete="off"
                              style={{borderColor:this.state.passwordError}}
                            />
                          </FormGroup>
                        </Col>
                        }
                        {(enabled.confirm_password == '0') &&
                        <Col md={4} xs={12}>
                          <FormGroup controlId="cpassword">
                            <ControlLabel>Confirm Password</ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.cpassword}
                              placeholder="Confirm Password"
                              onChange={this.handleChange}
                              name="cpassword"
                              autoComplete="off"
                              style={{borderColor:this.state.cpasswordError}}
                              
                            />
                          </FormGroup>

                      </Col>
                      }

                      {(this.state.charity && this.state.charityOption == 'enable') &&
                        <Col md={4} xs={4}>
                          <ControlLabel>Charity:</ControlLabel>
                          <FormControl
                            value={this.state.charity_id}
                            onChange={this.handleChange}
                            componentClass="select"
                            name="charity_id"
                            placeholder="select"
                          >
                            <option value="">Please select charity</option>
                            {this.state.charity.map((data, key) => 
                              <option key={data.charity_id} value={data.charity_id}>{data.charity_name}</option>
                            )}
                          </FormControl>
                        </Col>
                        }
                    </Row>
                    <Row>
                      <Col md={4} xs={12}>
                        {/*<Recaptcha
                                                  sitekey="6LdesVMUAAAAACp4xxdmSMWO2vGcIcjqj16uFmv_"
                                                />*/}
                      </Col>
                    </Row>
                  </div>
                </div>

                <Row>
                  <Col md={12} xs={12}>
                    <Checkbox name="term_condition" defaultValue="true" defaultChecked={true}>
                      I agree to {this.state.siteName} Terms of Use and Privacy Policy
                    </Checkbox>
                  </Col>
                  <Col md={12} xs={12}>
                    <Button 
                      bsStyle="success" 
                      style={{backgroundColor: (this.state.hover && this.state.hoverID == 'register') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                      data-id = {'register'}
                      onMouseEnter={this.hoverOn} 
                      onMouseLeave={this.hoverOff} 
                      type="submit" 
                      disabled={this.state.disabled}
                    >Create Account</Button>
                  </Col>
                </Row>
            </div>
          </form>
      </div>
    );
  }
}


Register.propTypes = {
 register: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  regStatus: state.frontReducer.regStatus,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  permission: state.frontReducer.becomePermission,
  getCharity: state.frontReducer.getCharity,
  cityList: state.frontReducer.cityList,
})



export default compose(
  connect(mapStateToProps,{register, renderAlert, clearAlert, partnerPermission, getcharityList, getSiteCity})
)(Register);


// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Register.js